import React from 'react';
import { Link } from 'react-router-dom';
import { StarIcon, QuoteIcon, CalendarIcon, EyeIcon } from 'lucide-react';
import { Hero } from '../components/Hero';
import { FeaturedCard } from '../components/FeaturedCard';
import { featuredGoods, featuredServices, upcomingEvents, latestNews, anonymousThoughts, clientReviews } from '../data/mockData';
export function HomePage() {
  return <main className="min-h-screen bg-gray-100" data-id="element-388">
      <Hero data-id="element-389" />

      {/* Featured Goods */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-390">
        <div className="flex items-center mb-8" data-id="element-391">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-392">Featured Goods</h2>
          <div className="flex-1 h-0.5 bg-blue-900 ml-4" data-id="element-393" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-394">
          {featuredGoods.map(item => <FeaturedCard key={item.id} listing={item} ctaText="View All Goods" ctaColor="blue" ctaLink="/goods" data-id="element-395" />)}
        </div>
      </section>

      {/* Featured Services */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-396">
        <div className="flex items-center mb-8" data-id="element-397">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-398">
            Featured Services
          </h2>
          <div className="flex-1 h-0.5 bg-blue-900 ml-4" data-id="element-399" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-400">
          {featuredServices.map(item => <FeaturedCard key={item.id} listing={item} ctaText="Explore Services" ctaColor="orange" ctaLink="/services" data-id="element-401" />)}
        </div>
      </section>

      {/* Upcoming Events */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-402">
        <div className="flex items-center mb-8" data-id="element-403">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-404">Upcoming Events</h2>
          <div className="flex-1 h-0.5 bg-blue-900 ml-4" data-id="element-405" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-406">
          {upcomingEvents.map(item => <FeaturedCard key={item.id} listing={item} ctaText="View All Events" ctaColor="red" ctaLink="/events" data-id="element-407" />)}
        </div>
      </section>

      {/* Latest News */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-408">
        <div className="flex items-center mb-8" data-id="element-409">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-410">Latest News</h2>
          <div className="flex-1 h-0.5 bg-blue-900 ml-4" data-id="element-411" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-412">
          {latestNews.map(item => <div key={item.id} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-413">
              <div className="h-48 overflow-hidden" data-id="element-414">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover" data-id="element-415" />
              </div>
              <div className="p-4" data-id="element-416">
                <h3 className="font-semibold text-gray-900 mb-2" data-id="element-417">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-sm text-gray-500 mb-3" data-id="element-418">
                  <div className="flex items-center space-x-1" data-id="element-419">
                    <CalendarIcon className="w-4 h-4 text-red-500" data-id="element-420" />
                    <span data-id="element-421">{item.createdAt}</span>
                  </div>
                  <div className="flex items-center space-x-1" data-id="element-422">
                    <EyeIcon className="w-4 h-4" data-id="element-423" />
                    <span data-id="element-424">{item.views} Views</span>
                  </div>
                </div>
                <Link to="/news" className="block w-full text-center py-2 rounded-md bg-red-600 hover:bg-red-700 text-white text-sm font-medium transition-colors" data-id="element-425">
                  Read More
                </Link>
              </div>
            </div>)}
        </div>
      </section>

      {/* Anonymous Thoughts */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-426">
        <h2 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-427">
          Anonymous Thoughts
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-428">
          {anonymousThoughts.map(thought => <div key={thought.id} className="bg-white rounded-lg shadow-md p-6 relative" data-id="element-429">
              <QuoteIcon className="w-8 h-8 text-orange-400 absolute top-4 left-4 opacity-50" data-id="element-430" />
              <p className="text-gray-700 text-center py-4 px-8 italic" data-id="element-431">
                "{thought.content}"
              </p>
              <QuoteIcon className="w-8 h-8 text-orange-400 absolute bottom-4 right-4 opacity-50 rotate-180" data-id="element-432" />
            </div>)}
        </div>
      </section>

      {/* Client Reviews */}
      <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-433">
        <div className="flex items-center mb-8" data-id="element-434">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-435">Client Reviews</h2>
          <div className="flex-1 h-0.5 bg-blue-900 ml-4" data-id="element-436" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-437">
          {clientReviews.map(review => <div key={review.id} className="bg-white rounded-lg shadow-md p-6" data-id="element-438">
              <div className="flex items-center space-x-3 mb-4" data-id="element-439">
                <img src={review.userAvatar} alt={review.userName} className="w-12 h-12 rounded-full" data-id="element-440" />
                <div data-id="element-441">
                  <p className="font-semibold text-gray-900" data-id="element-442">
                    {review.userName}
                  </p>
                  <div className="flex" data-id="element-443">
                    {[...Array(review.rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-444" />)}
                  </div>
                </div>
              </div>
              <p className="text-gray-600 mb-4" data-id="element-445">{review.comment}</p>
              <button className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded text-sm font-medium transition-colors" data-id="element-446">
                Read More
              </button>
            </div>)}
        </div>
      </section>
    </main>;
}